import React from 'react'
import { Dropdown, IconButton } from 'rsuite';
import MenuIcon from '@rsuite/icons/Menu';
import PageIcon from '@rsuite/icons/Page';
import "rsuite/dist/rsuite.min.css";

import '../App.css';
// TODO: This is missing functionality for sub-menu here from SUI core examples.
// The "Publish To Web" item should contain a sub-menu.

const renderIconButton = (props, ref) => {
  return (
    <IconButton {...props} ref={ref} icon={<MenuIcon style={{ fontSize: 14 }}/>} circle appearance="subtle" />
  );
};

const DropdownExampleDropdown = ({ items, onPress }) => (
  <div className="App-dropdown">
    <Dropdown renderToggle={renderIconButton}
      placement="leftStart"
    >
      {items.map((item, index) => {
        return <Dropdown.Item onSelect={() => onPress(index)} key={item}>
        {item}
      </Dropdown.Item>
      })}
    </Dropdown>
  </div>
)

export default DropdownExampleDropdown